import { LOCAL_STORAGE_KEY, OPERATING_SYSTEM, PLATFORM, RAILTYPE } from "../constant";
import { utility } from "../utility/utility";

const CMSURL = {
  BASEURL: "https://bmsuat.bossstudio.tv",
  //BASEURL: "http://localhost:8001",
}

// BASEURL: "http://143.110.252.28:5000/v2/data/getLayout"

const GetHeader = (method = 'GET') => {
  return {
    method: method,
    accept: 'application/json',
    headers: {
      'Content-Type': 'application/json',
      'x-access-token': "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyTmFtZSI6ImFkbWluIiwicGFzc3dvcmQiOiJhYmNkMTIzNCIsImlhdCI6MTc1MzI0MzY0MiwiZXhwIjoxNzUzMzMwMDQyfQ.Xo_ixOlb8VbZC3ML7GL9XPDMODWY-DzGEK5kBjhL53s"
    },
  }
}

export async function getLayout() {

  try {
    let FINALURL = CMSURL.BASEURL + '/v2/data/getLayout';
    let Finalinit = { ...GetHeader() };
    console.log(FINALURL)
    const response = await fetch(FINALURL, Finalinit);
    console.log(response);
    const responseData = await response.json();

    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function getPage(id) {

  try {
    // old
    // let FINALURL = CMSURL.BASEURL + '/v2/ott/getPageById';
    // let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify({ _id: id }) };
    let isoCode = utility.getValue(LOCAL_STORAGE_KEY.language)?.ISOCode || "en_US1";
    let FINALURL = CMSURL.BASEURL + '/v2/ott/getPageByIdV2ByISOCode';
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify({ _id: id, isoCode: isoCode }) };
    console.log(FINALURL)
    const response = await fetch(FINALURL, Finalinit);
    let responseData = await response.json();

    // filter rails inside page which has ott assets 
    if (responseData['success'] && responseData['data'] != null && responseData['data']['Rails'] != null) {

      let finalRails = [];
      responseData['data']['Rails'].forEach(r => {
        if (r['OttRailTypeSID'].toString() == (RAILTYPE.TEXT).toString()
          || r['OttRailTypeSID'].toString() == (RAILTYPE.FastChannel).toString()
          || r['OttRailTypeSID'].toString() == (RAILTYPE.FastChannelWithNavigation).toString()
          || (r['OttAsset'] != null && r['OttAsset'].length > 0)) {
          finalRails.push(r);
        }
      });

      responseData['data']['Rails'] = finalRails;
    }

    console.log(responseData);
    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function getEpg() {

  try {
    let FINALURL = CMSURL.BASEURL + '/v2/ott/getEPG';
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify({ date: new Date().getTime() }) };
    console.log(FINALURL)
    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    console.log(responseData);

    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function geVideoPlaybackURL(ottAsset, platform) {
  try {
    let FINALURL = CMSURL.BASEURL + '/v2/ott/getPlaybackUrl';
    let Finalinit = {
      ...GetHeader('POST'), "body": JSON.stringify({
        "ottAsset": ottAsset,
        "content_id": ottAsset._id,
        "videotype": platform
      })
    };
    console.log(FINALURL)
    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    console.log(responseData);

    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }
}


export async function getBottomMenu() {

  try {
    // old
    // let FINALURL = CMSURL.BASEURL + '/v2/ott/getBottomMenu';
    // let Finalinit = { ...GetHeader() };
    let isoCode = utility.getValue(LOCAL_STORAGE_KEY.language)?.ISOCode || "en_US1";
    let FINALURL = CMSURL.BASEURL + '/v2/ott/getBottomMenuByISOCode';
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify({ isoCode: isoCode }) };
    console.log(FINALURL)
    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    console.log(responseData);

    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

export async function getUpcomingRailAssets() {

  try {
    // old
    // let FINALURL = CMSURL.BASEURL + '/v2/ott/getBottomMenu';
    // let Finalinit = { ...GetHeader() };
    let isoCode = utility.getValue(LOCAL_STORAGE_KEY.language)?.ISOCode || "en_US1";
    let FINALURL = CMSURL.BASEURL + '/v2/ott/upcomingAssetsByIsoCode';
    let Finalinit = { ...GetHeader('POST'), "body": JSON.stringify({ isoCode: isoCode, limit: 100 }) };
    console.log(FINALURL)
    const response = await fetch(FINALURL, Finalinit);
    const responseData = await response.json();
    console.log(responseData);

    return responseData;
  }
  catch (error) {
    console.log("error", error);
    return { success: false, message: error.message, error: error };
  }

}

//default args
let defaultArgs = {
  // MULTIPLE QUERRY EX: [ ['SID', '>', '0'], ['SID', '>', '0'], ['SID', '>', '0']  ]
  // SINGLE QUERRY EX: ['SID', '>', '0']
  query: [],
  // SORT ASC EX: { SID : 1 }
  // SORT DESC EX: { SID : -1 }
  // MULTIPLE SORTS EX: { SID : 1, DATE : -1 }
  sort: { SID: 1 },
  // 1 MEANS FIRST PAGE, 2 MEANS 2 PAGE
  page: null,
  // NO. OF ITEMS PER PAGE
  perPage: null,
  //ARCHIVE KEY
  archive: false
}

export async function getData(entityname, args = defaultArgs) {
  try {
    let finalData = {
      query: args.query || defaultArgs.query,
      sort: args.sort || defaultArgs.sort,
      page: args.page || defaultArgs.page,
      perPage: args.perPage || defaultArgs.perPage,

    };
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify(finalData) };
    let FINALURL = CMSURL.BASEURL + '/v2/data/getEntities/' + entityname;
    // console.log(finalData);
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function getOttSettings(args = defaultArgs) {
  try {
    let Finalinit = {
      ...GetHeader("POST"), "body": JSON.stringify(
        { platform: PLATFORM.filter(x => x.Description === "Web")[0].SID }
      )
    };
    let FINALURL = CMSURL.BASEURL + '/v2/ott/getOttSetting';
    // console.log(finalData);
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function getAllProfiles(Subscriber_id) {
  try {
    let Finalinit = {
      ...GetHeader("POST"), "body": JSON.stringify(
        { Subscriber_id: Subscriber_id }
      )
    };
    let FINALURL = CMSURL.BASEURL + '/v2/login/getAllProfiles';
    // console.log(finalData);
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function getAssetByID(id) {
  try {
    // old
    // let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify({ _id: id }) };
    // let FINALURL = CMSURL.BASEURL + '/v2/ott/getAssetById';
    let isoCode = utility.getValue(LOCAL_STORAGE_KEY.language)?.ISOCode || "en_US1";
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify({ _id: id, isoCode: isoCode }) };
    let FINALURL = CMSURL.BASEURL + '/v2/ott/getAssetByISOCode';
    // console.log(finalData);
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function getAllPages() {
  try {
    let Finalinit = { ...GetHeader("POST") };
    let FINALURL = CMSURL.BASEURL + '/v2/ott/getAllPages';
    // console.log(finalData);
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function getMoreMoviesLikeThis(genre) {
  try {
    let isoCode = utility.getValue(LOCAL_STORAGE_KEY.language)?.ISOCode || "en_US1";
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify({ genre: genre, isoCode: isoCode }) };
    // let FINALURL = CMSURL.BASEURL + '/v2/ott/getAssetsByGenre';
    let FINALURL = CMSURL.BASEURL + '/v2/ott/getAssetsByGenreByISOCode';

    // console.log(finalData);
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function sendOTP(user) {
  try {
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify({ data: { "recipient": user } }) };
    let FINALURL = CMSURL.BASEURL + '/v2/message/sendOTP';
    const response = await fetch(FINALURL, Finalinit);
    console.log(response);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function getSubscriber(mobileNumber) {
  try {
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify({ "mobileNumber": mobileNumber }) };
    let FINALURL = CMSURL.BASEURL + '/v2/login/getSubscriber';
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function getLoggedDevices(subscriberId) {
  try {
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify({ "subscriberId": subscriberId }) };
    let FINALURL = CMSURL.BASEURL + '/v2/login/getLoggedDevices';
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function removeDevice(subscriberId, serialNumber) {
  try {
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify({ "subscriberId": subscriberId, "serialNumber": serialNumber }) };
    let FINALURL = CMSURL.BASEURL + '/v2/login/removeDevice';
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function checkConcurrency(subscriberId, deviceName) {
  try {
    let ipaddressRes = await fetch('https://api.ipify.org?format=json');
    let ipaddress = await ipaddressRes.json().then((data) => data['ip']);
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify({ "subscriberId": subscriberId, "serialNumber": ipaddress, "deviceName": deviceName }) };
    let FINALURL = CMSURL.BASEURL + '/v2/login/checkConcurrency';
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function getIsUserLoggedIn(subscriberId, ottAsset) {
  try {
    console.log(ottAsset);
    let ipaddressRes = await fetch('https://api.ipify.org?format=json');
    let ipaddress = await ipaddressRes.json().then((data) => data['ip']);
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify({ "subscriberId": subscriberId, "serialNumber": ipaddress, "provider_id": ottAsset?.Provider?._id ?? "", "provider_Name": ottAsset?.Provider?.Description ?? "" }) };
    let FINALURL = CMSURL.BASEURL + '/v2/login/getIsUserLoggedIn';
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    console.log(data);
    console.log(Finalinit);
    return data;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function getPlansByRegion() {
  try {

    let subscriber = utility.getValue(LOCAL_STORAGE_KEY.user)
    let region = "";
    if (subscriber) {
      region = subscriber?.Region?.Description ?? "Asia pacific";
    }

    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify({ "region": region, "OS": OPERATING_SYSTEM.Web }) };
    let FINALURL = CMSURL.BASEURL + '/v2/ott/getPlansByRegion';
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function addDevice(subscriberId, deviceName) {
  // loggedInDeviceData:{
  //   "serialNumber": serialNumber,
  //   "deviceName": deviceName,
  //   "lastLoginTime": lastLoginTime
  // }
  try {
    // ipaddress
    let ipaddressRes = await fetch('https://api.ipify.org?format=json');
    let ipaddress = await ipaddressRes.json().then((data) => data['ip']);
    let Finalinit = {
      ...GetHeader("POST"), "body": JSON.stringify({
        "subscriberId": subscriberId,
        "loggedInDeviceData": {
          serialNumber: ipaddress,
          deviceName: deviceName,
          lastLoginTime: new Date().getTime()
        }
      })
    };
    let FINALURL = CMSURL.BASEURL + '/v2/login/addDevice';
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}


export async function saveSubscriberLoginHistory(subscriberId, displayPlatform) {
  try {

    let Finalinit = {
      ...GetHeader("POST"), "body": JSON.stringify({
        "subscriberId": subscriberId,
        "platform": displayPlatform
      })
    };
    let FINALURL = CMSURL.BASEURL + '/v2/login/saveSubscriberLoginHistory';
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function globalSearch(searchKey) {
  try {
    let isoCode = utility.getValue(LOCAL_STORAGE_KEY.language)?.ISOCode || "en_US1";
    let Finalinit = { ...GetHeader("POST"), "body": JSON.stringify({ "isoCode": isoCode }) };
    let FINALURL = `${CMSURL.BASEURL}/v2/ott/searchOttAssetsByISOCode/${searchKey.toString()}`;
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function saveProfile(profileToSave) {
  try {
    let profile = { ...profileToSave };
    delete profile["addNew"];
    let Finalinit = {
      ...GetHeader("POST"),
      "body": JSON.stringify({
        "Subscriber_id": profile.SubscriberId,
        "profile": profile
      })
    };
    let FINALURL = `${CMSURL.BASEURL}/v2/login/saveProfile`;
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function deleteProfile(profileToDelete) {
  try {
    let Finalinit = {
      ...GetHeader("POST"),
      "body": JSON.stringify({
        "profileId": profileToDelete._id,
        "Subscriber_id": profileToDelete.SubscriberId
      })
    };
    let FINALURL = `${CMSURL.BASEURL}/v2/login/deleteProfile`;
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function getPgRatings() {
  try {
    let Finalinit = {
      ...GetHeader("POST")
    };
    let FINALURL = `${CMSURL.BASEURL}/v2/ott/getPgRatings`;
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function getLanguages() {
  try {
    let Finalinit = {
      ...GetHeader("POST")
    };
    let FINALURL = `${CMSURL.BASEURL}/v2/login/getLanguages`;
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function getRegions() {
  try {
    let Finalinit = {
      ...GetHeader("POST")
    };
    let FINALURL = `${CMSURL.BASEURL}/v2/config/getRegions`;
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function signUpSubscriber(item) {
  try {
    let Finalinit = {
      ...GetHeader("POST"),
      "body": JSON.stringify(item)
    };
    let FINALURL = `${CMSURL.BASEURL}/v2/login/signUpSubscriber`;
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}

export async function updateSubscriber(id, name, email) {
  try {
    let Finalinit = {
      ...GetHeader("POST"),
      "body": JSON.stringify({
        id: id,
        Name: name,
        Email: email,
      })
    };
    let FINALURL = `${CMSURL.BASEURL}/v2/login/updateUser`;
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.log("error", error.message);
    return { success: false, message: error.message, error: error };
  }
}


export async function createRazorpayOrder({ amount, currencyCode, userID, plan }) {
  try {
    const finalInit = {
      ...GetHeader("POST"),
      body: JSON.stringify({ amount, currencyCode, userID, plan }),
    };

    const finalURL = `${CMSURL.BASEURL}/v2/razorpay/createOrder`;
    const response = await fetch(finalURL, finalInit);
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("createOrder error:", error.message);
    return { success: false, message: error.message };
  }
}

export async function verifyRazorpayPayment(responseObj) {
  try {
    const finalInit = {
      ...GetHeader("POST"),
      body: JSON.stringify(responseObj),
    };

    const finalURL = `${CMSURL.BASEURL}/v2/razorpay/verifyPayment`;
    const response = await fetch(finalURL, finalInit);
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("verifyPayment error:", error.message);
    return { success: false, message: error.message };
  }
}

export async function upateSubscriberPackage({ Subscriber_id, Package_id, orderId, paymentId }) {
  try {
    let Finalinit = {
      ...GetHeader("POST"),
      "body": JSON.stringify({ Subscriber_id, Package_id, orderId, paymentId })
    };
    let FINALURL = `${CMSURL.BASEURL}/v2/ott/updateSubscriberPackage`;
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("upateSubscriberPackage error:", error.message);
    return { success: false, message: error.message };
  }
}

export async function createStripeCheckoutSession({ amount, currencyCode, plan, userID }) {
  try {
    const finalInit = {
      ...GetHeader("POST"),
      body: JSON.stringify({ amount, currencyCode, plan, userID }),
    };
    const finalURL = `${CMSURL.BASEURL}/v2/stripe/createCheckoutSession`;
    const response = await fetch(finalURL, finalInit);
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("createStripeCheckoutSession error:", error.message);
    return { success: false, message: error.message };
  }
}

export async function getStripeCheckoutSession(session_id) {
  try {
    const finalInit = {
      ...GetHeader("GET"),
    };
    const finalURL = `${CMSURL.BASEURL}/v2/stripe/getCheckoutSession?session_id=${session_id}`;
    const response = await fetch(finalURL, finalInit);
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("getStripeCheckoutSession error:", error.message);
    return { success: false, message: error.message };
  }
}

export async function createPaypalOrder({ amount, currencyCode, plan, userID }) {
  try {
    const finalInit = {
      ...GetHeader("POST"),
      body: JSON.stringify({ amount, currencyCode, plan, userID }),
    };
    const finalURL = `${CMSURL.BASEURL}/v2/paypal/createPaypalOrder`;
    const response = await fetch(finalURL, finalInit);
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("createPaypalOrder error:", error.message);
    return { success: false, message: error.message };
  }
}

export async function capturePaypalOrder(orderId) {
  try {
    const finalInit = {
      ...GetHeader("POST"),
      body: JSON.stringify({ orderId }),
    };
    const finalURL = `${CMSURL.BASEURL}/v2/paypal/capturePaypalOrder`;
    const response = await fetch(finalURL, finalInit);
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("capturePaypalOrder error:", error.message);
    return { success: false, message: error.message };
  }
}

export async function subscribeToTopic(token, topic) {
  try {
    const finalInit = {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ token, topic }),
    };

    const finalURL = `${CMSURL.BASEURL}/v2/firebase/subscribeToTopic`;
    const response = await fetch(finalURL, finalInit);
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("subscribeToTopic error:", error.message);
    return { success: false, message: error.message };
  }
}

export async function unsubscribeFromTopic(token, topic) {
  try {
    const finalInit = {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ token, topic }),
    };

    const finalURL = `${CMSURL.BASEURL}/v2/firebase/unsubscribeFromTopic`;
    const response = await fetch(finalURL, finalInit);
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("subscribeToTopic error:", error.message);
    return { success: false, message: error.message };
  }
}

export async function getSeries(ottAsset) {
  try {
    let isoCode = utility.getValue(LOCAL_STORAGE_KEY.language)?.ISOCode || "en_US1";
    const finalInit = {
      ...GetHeader("POST"),
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({       
        _id: ottAsset._id,
        mediaCategorySID: ottAsset?.MediaCategory,
        isoCode: isoCode
      }),
    }
    const finalURL = `${CMSURL.BASEURL}/v2/ott/getSeaonWithEpisodeAssetByIdByISOCode`;
    const response = await fetch(finalURL, finalInit);
    const data = await response.json();
    return data;
  } catch (error) {
    return { success: false, message: error.message, error: error };
  }
}

export async function generateCode() {
  try {
    let ipaddressRes = await fetch('https://api.ipify.org?format=json');
    let ipaddress = await ipaddressRes.json().then((data) => data['ip']);
    let Finalinit = {
      ...GetHeader("POST"), "body": JSON.stringify(
        { serialNumber: ipaddress}
      )
    };
    let FINALURL = CMSURL.BASEURL + '/v2/message/generateCode';
    // console.log(finalData);
    const response = await fetch(FINALURL, Finalinit);
    const data = await response.json();
    return data;
  }
  catch (error) {
    return { success: false, message: error.message, error: error };
  }
}